<template>
  <ValidatingOfferCardContainer
    v-bind="$attrs"
    :offer="offer"
    product-label="Veículo em garantia"
    @display-partner-validating-steps="
      displayPartnerValidatingStepsModal = true
    "
  >
    <template #modal>
      <component
        :is="cptdPartnerValidatingStepsModal"
        v-if="displayPartnerValidatingStepsModal"
        :display="displayPartnerValidatingStepsModal"
        @close="displayPartnerValidatingStepsModal = false"
      />
    </template>
  </ValidatingOfferCardContainer>
</template>
<script>
import { Partner } from '@/data/common'
import Button from '@/aasgard/components/buttons/Button.vue'
import ValidatingOfferCardContainer from '@/containers/loans/ValidatingOfferCardContainer.vue'
import Badge from '@/aasgard/components/feedback/Badge.vue'
import CREDITAS_PARTNER_VALIDATING_STEPS_BOTTOM_SHEET from '@/containers/loans/auto/offer/partners/CreditasPartnerValidatingStepsBottomSheet.vue'
export default {
  name: 'AutoValidatingOfferCardContainer',
  components: {
    Button,
    ValidatingOfferCardContainer,
    Badge,
    CREDITAS_PARTNER_VALIDATING_STEPS_BOTTOM_SHEET,
  },
  props: {
    offer: { type: Object, required: true },
  },
  data() {
    return {
      displayPartnerValidatingStepsModal: false,
    }
  },
  computed: {
    cptdPartnersModal() {
      return [Partner.CREDITAS]
    },
    cptdOfferDurationMax() {
      return this.offer?.duration_max ?? 0
    },
    cptdMonthlyInterestRate() {
      return (this.offer?.interest_rate_monthly ?? 0)
        ?.toFixed(2)
        ?.replace('.', ',')
    },
    cptdPartnerValidatingStepsModal() {
      const { partner } = this.offer
      if (this.cptdPartnersModal.includes(partner)) {
        return `${partner}_PARTNER_VALIDATING_STEPS_BOTTOM_SHEET`
      }
      return ''
    },
    cptdPartnerHasValidatingStepsModal() {
      return this.cptdPartnerValidatingStepsModal !== ''
    },
  },
}
</script>
<style lang="scss"></style>
